import React from "react";

const ReactJsRealisations = () => {
    return (
        <div>
            {/* <h2 className="mb-5"><strong>Réalisations</strong></h2> */}
            <p className="pRealisations">
                Ce portfolio est ma première réalisation totalement personnelle et sans template, (développée avec REACT-JS/HTML5/CSS3/BOOTSTRAP, le formulaire est fonctionnelle grâce à une API développée en NODEJS qui utilise le service d'une autre API de mailing (SENDGRID), la partie front est déployée sur NETLIFY et le back(API) sur HEROKU).Les fichiers (images et vidéos) de certains projets (ceux qui ont une base de données) sont stockés sur le service AWS S3.<br />
                Cette partie sera alimentée et mise à jour régulièrement.<br />
                Ici quelque unes de mes réalisations avec des liens pour celles deployées et des illustrations (vidéos) pour celles que j'ai pas pu déployer parce que realisées pour un client de l'entreprise pendant mon stage. Pour les consulter cliquer sur le logo du langage principale de l'application correpondant dans la side-bare à gauche de cet écran.<br/>Pour les codes sources, sont disponibles sur ma GitHub.
            </p>
        </div>
    )
}

export default ReactJsRealisations;